var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.627,
    height: 14.688,
    viewBox: "0 0 10.627 14.688",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "smartphone",
    transform: "translate(-4.15 -1.149)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2693",
    "data-name": "Group 2693",
    transform: "translate(4.15 1.149)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M1.929,14.688A1.931,1.931,0,0,1,0,12.76V1.929A1.932,1.932,0,0,1,1.929,0H8.7a1.932,1.932,0,0,1,1.929,1.929V12.76A1.931,1.931,0,0,1,8.7,14.688ZM1.151,1.929V12.76a.778.778,0,0,0,.779.778H8.7a.779.779,0,0,0,.779-.778V1.929A.78.78,0,0,0,8.7,1.151H1.929A.779.779,0,0,0,1.151,1.929ZM3.96,12.421a.575.575,0,1,1,0-1.151H6.667a.575.575,0,1,1,0,1.151Z",
    fill: "#212121"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneicon);
export default __webpack_public_path__ + "static/media/phoneicon.382c8b37a9db960a5cbf226ed955851f.svg";
export { ForwardRef as ReactComponent };